export default {
    open: "Responde ahora",
    approve: "Aprobar ahora",
    impersonation: {
        title: "Estás realizando el pedido en nombre de «{name}»",
        cta: "Volver a mí mismo",
    },
    "You have an unapproved orders": "Tienes pedidos para aprobar",
    "You have orders to approve": "Tienes pedidos para aprobar"
}